import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const SelectButton = ({ options, selectedValue, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const handleToggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleOptionClick = (option) => {
    onSelect(option);
    setIsOpen(false); // Close dropdown after selection
  };

  return (
    <div className="relative sm:max-w-sm">
      {/* Dropdown Button */}
      <div
        className={`${
          location.pathname.includes("registration")
            ? "md:w-full w-[10rem]"
            : "md:w-[9rem] w-[7rem]"
        } text-[#777777] text-sm font-normal leading-tight flex items-center justify-between px-3 py-2 border rounded cursor-pointer `}
        onClick={handleToggleDropdown}
      >
        <span className="truncate">{selectedValue || "All"}</span>
        {/* Arrow Icon */}
        <span>
          {isOpen ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 text-[#777777]"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M14.77 12.79a.75.75 0 01-1.06-.02L10 9.414l-3.71 3.355a.75.75 0 01-1.04-1.086l4-3.75a.75.75 0 011.04 0l4 3.75a.75.75 0 01-.02 1.06z"
                clipRule="evenodd"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 text-[#777777]"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M5.23 7.21a.75.75 0 011.06.02L10 10.586l3.71-3.355a.75.75 0 011.04 1.086l-4 3.75a.75.75 0 01-1.04 0l-4-3.75a.75.75 0 01.02-1.06z"
                clipRule="evenodd"
              />
            </svg>
          )}
        </span>
      </div>

      {/* Dropdown Options */}
      {isOpen && (
        <ul
          className="absolute w-full bg-white border border-gray-300 rounded mt-1 shadow-lg 
            max-h-40 overflow-y-auto z-10 md:max-w-sm lg:max-w-md"
        >
          {options.map((option, index) => (
            <li
              key={index}
              className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm text-[#777777] truncate"
              onClick={() => handleOptionClick(option)}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SelectButton;
